import type { PublicApiKey } from '@/apilib';
import type { createPagesApi } from './pagesWrapper';

export const PagesApiKey: PublicApiKey<typeof createPagesApi> = {
  name: 'PagesApi',
  public: true,
};
